import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';

import {
  ActivitiesDataScope,
  NotificationsActions,
} from '@recruitee/activities-and-notifications-data';
import type { ActivitiesFiltersParams } from '@recruitee/activities-types';

@Injectable({ providedIn: 'root' })
export class NotificationReadUnreadService {
  private ngOnDestroy$ = new Subject<void>();

  constructor(private store: Store) {}

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public markAllNotificationAsRead() {
    this.store.dispatch(NotificationsActions.markAllViewed());
  }

  public markNotificationAsReadUnread(read: boolean, id: number) {
    read
      ? this.store.dispatch(NotificationsActions.markAsNotViewed({ payload: [id] }))
      : this.store.dispatch(NotificationsActions.markAsViewed({ payload: [id] }));
  }

  public showAllOrUnread(
    scope: ActivitiesDataScope,
    filters: ActivitiesFiltersParams,
    replace: boolean,
  ) {
    this.store.dispatch(
      NotificationsActions.fetchCollection({
        payload: {
          params: filters,
          scope: scope,
          replace: replace,
        },
      }),
    );
  }

  public loadNotification(showUnread: boolean, filters: ActivitiesFiltersParams, replace: boolean) {
    this.store.dispatch(
      NotificationsActions.fetchCollection({
        payload: {
          params: filters,
          scope: showUnread ? ActivitiesDataScope.AllUnread : ActivitiesDataScope.All,
          replace: replace,
        },
      }),
    );
  }
}
